import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Plus, Clock, IndianRupee, BookOpen } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";

export default function CoursesPage() {
  const [courses, setCourses] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name:"", code:"", duration_months:12, fee:50000, description:"" });

  const load = async () => setCourses((await api.get("/courses")).data);
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    await api.post("/courses", { ...form, duration_months: Number(form.duration_months), fee: Number(form.fee), subjects: [] });
    setOpen(false); toast.success("Course created"); load();
  };

  return (
    <div>
      <PageHeader
        title="Courses"
        subtitle={`${courses.length} programs on offer`}
        actions={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><button className="btn-primary flex items-center gap-2" data-testid="add-course-btn"><Plus size={16}/> New course</button></DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Create course</DialogTitle></DialogHeader>
              <form onSubmit={create} className="space-y-3">
                <input required placeholder="Course name" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" data-testid="course-name-input" value={form.name} onChange={e=>setForm({...form, name:e.target.value})}/>
                <div className="grid grid-cols-2 gap-2">
                  <input required placeholder="Code" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" data-testid="course-code-input" value={form.code} onChange={e=>setForm({...form, code:e.target.value})}/>
                  <input type="number" required placeholder="Duration (months)" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" data-testid="course-duration-input" value={form.duration_months} onChange={e=>setForm({...form, duration_months:e.target.value})}/>
                </div>
                <input type="number" required placeholder="Fee (INR)" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" data-testid="course-fee-input" value={form.fee} onChange={e=>setForm({...form, fee:e.target.value})}/>
                <textarea placeholder="Description" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" data-testid="course-desc-input" value={form.description} onChange={e=>setForm({...form, description:e.target.value})}/>
                <DialogFooter><button type="submit" className="btn-primary" data-testid="course-save-btn">Save course</button></DialogFooter>
              </form>
            </DialogContent>
          </Dialog>
        }
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {courses.map((c) => (
          <div key={c.id} className="linkedin-card p-5 hover:border-[#0A66C2]" data-testid={`course-card-${c.id}`}>
            <div className="flex items-start justify-between">
              <div className="w-10 h-10 rounded-md bg-[#EAF3FB] text-[#0A66C2] flex items-center justify-center"><BookOpen size={20}/></div>
              <span className="text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded bg-[#F4F2EE] text-[#00000099]">{c.code}</span>
            </div>
            <div className="mt-3 font-semibold text-[16px] text-[#000000E6]">{c.name}</div>
            <div className="text-xs text-[#00000099] mt-1 line-clamp-2 min-h-[32px]">{c.description}</div>
            <div className="flex items-center justify-between mt-4 pt-3 border-t border-[#E0DFDC]">
              <div className="flex items-center gap-1 text-xs text-[#00000099]"><Clock size={12}/> {c.duration_months} months</div>
              <div className="flex items-center gap-1 text-sm font-semibold text-[#0A66C2]"><IndianRupee size={13}/> {(c.fee||0).toLocaleString('en-IN')}</div>
            </div>
            {c.subjects?.length ? (
              <div className="flex flex-wrap gap-1 mt-3">
                {c.subjects.slice(0, 5).map((s, i) => (
                  <span key={i} className="text-[10px] px-2 py-0.5 rounded bg-[#EAF3FB] text-[#0A66C2] font-medium">{s}</span>
                ))}
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
}
